import React from "react";
import { useNavigate } from "react-router-dom";

const Course = ({ course,session }) => {
  const navigate = useNavigate();
const getStatusColor = (status) => {
  switch (status) {
    case 'marksentry':
      return 'from-pink-300 to-pink-200 hover:from-pink-700 hover:to-pink-500';
    case 'gradecomputation':
      return 'from-yellow-300 to-yellow-200 hover:from-yellow-600 hover:to-yellow-400';
    case 'done':
      return 'from-green-300 to-green-200 hover:from-green-600 hover:to-green-400';
       case 'partialgradecomputation':
      return 'from-yellow-300 to-green-200 hover:from-yellow-600 hover:to-green-400';
         case 'partialmarksentry':
      return 'from-pink-300 to-yellow-200 hover:from-pink-600 hover:to-yellow-400';      
    default:
      return 'from-blue-300 to-blue-200 hover:from-blue-600 hover:to-blue-400';
  }
};
  const handleCardClick = () => {
    // Redirect to a dummy route
      sessionStorage.setItem("scrollPositionge", document.querySelector("main")?.scrollTop || 0);
    navigate(`/gradeentrybatches/${course.code}/${session}`); 
  };

  let camelCaseTitle=course.title
  .split(' ')
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(' ');
   return (
    <div
        onClick={handleCardClick}
       className={`w-[190px] h-[175px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300 text-xs
    bg-gradient-to-r ${getStatusColor(course.submissionStatus)} hover:text-white`}>
                     <p className="w-full text-xs  text-center  mb-2">{course.level}-{course.semester}</p>
        <p className="w-full text-xs  text-center mb-2 font-semibold">{course.code}</p>
        

        <p className="w-full text-xs  break-words whitespace-normal text-center " title={course.title}>
            {camelCaseTitle.length > 30 ? `${camelCaseTitle.slice(0,25)}...` : camelCaseTitle}
        </p>
       
       <div className="flex mt-4 gap-1"> 
          <div className="flex-1 flex flex-col justify-center items-center p-1">
             <label>
                 MARK 
             </label>
             <p className="font-semibold">
 {course.marksentry}
             </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center p-1">
             <label>
GRADE 
             </label>
             <p className="font-semibold">
               {course.gradecomputation}
             </p>
          </div>
        </div>

    </div>


  );
};

export default Course;
